/* Minent — Calculateur de rentabilité v2
 * Hydratation légère : le HTML est rendu côté serveur, ce script ne fait que
 * (1) rafraîchir les données live (prix crypto + paramètres réseau),
 * (2) recalculer les cellules en place, (3) tri / filtres / recherche.
 * Aucune reconstruction du DOM.
 */
(function () {
  "use strict";
  var root = document.getElementById("mc-root");
  var dataEl = document.getElementById("mc-data");
  var D = window.MC_DATA || (dataEl ? JSON.parse(dataEl.textContent) : null);
  if (!root || !D) return;
  var MINERS = D.miners; // [{id,n,b,a,c,hr,u,w,cl,tag,price,url,avail}]
  var NET = D.net;       // fallback baked at generation, refreshed live
  var PRICES = D.prices; // {BTC:{eur,..},...} baked, refreshed live
  var CG = D.cg;         // coin -> coingecko id
  var TWO32 = 4294967296;
  var UNIT = { "TH/s": 1e12, "GH/s": 1e9, "MH/s": 1e6, "KH/s": 1e3, "Ksol/s": 1e3 };

  var state = { el: D.elec, fC: "", fCl: "", fB: "", fA: "", fS: "", q: "", sortK: "pf", sortD: "desc" };
  var live = { prices: false, net: false };
  /* libellés localisés rendus côté serveur (data-attributes sur #mc-root) */
  var L = {
    day: root.getAttribute("data-day") || "/j",
    days: root.getAttribute("data-days") || " j",
    machines: root.getAttribute("data-machines") || "machines",
    live: root.getAttribute("data-live") || "● Live",
    sync: root.getAttribute("data-sync") || "● Sync…",
    priceLabel: root.getAttribute("data-price-label") || "Prix :",
    instock: root.getAttribute("data-instock") || "",
    preorder: root.getAttribute("data-preorder") || "",
    out: root.getAttribute("data-out") || "",
    cta: root.getAttribute("data-cta") || "",
    perday: root.getAttribute("data-perday") || "/jour"
  };

  var tbody = root.querySelector("tbody");
  var rows = {};   // id -> tr
  Array.prototype.forEach.call(tbody.querySelectorAll("tr[data-id]"), function (tr) {
    rows[tr.getAttribute("data-id")] = tr;
  });

  /* ---------- calcul ---------- */
  function calc(m) {
    var ep = PRICES[m.c] ? PRICES[m.c].eur : 0;
    var hps = m.hr * (UNIT[m.u] || 1);
    var net = NET[m.c], rev = 0;
    if (net && ep > 0) {
      if (net.type === "diff") rev = (hps * 86400 * net.reward) / (net.diff * TWO32) * ep;
      else rev = (hps / net.nh) * (86400 / net.bt) * net.reward * ep;
    }
    if (m.c === "LTC") { /* merged mining DOGE */
      var dn = NET.DOGE, dp = PRICES.DOGE ? PRICES.DOGE.eur : 0;
      if (dn && dp > 0) rev += (hps * 86400 * dn.reward) / (dn.diff * TWO32) * dp;
    }
    var ec = (m.w / 1000) * 24 * state.el;
    var pf = rev - ec;
    var roi = (m.price && pf > 0) ? Math.ceil(m.price / pf) : null;
    return { rev: rev, ec: ec, pf: pf, roi: roi };
  }

  function eur(v, dec) {
    return v.toLocaleString("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function fmtPrice(v) {
    var dec = v >= 1000 ? 0 : v >= 1 ? 2 : 4;
    return v.toLocaleString("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  /* ---------- mise à jour des cellules en place ---------- */
  var vals = {}; // id -> dernières valeurs calculées (pour le tri)
  function refreshRows() {
    MINERS.forEach(function (m) {
      var tr = rows[m.id]; if (!tr) return;
      var r = calc(m);
      vals[m.id] = r;
      var has = r.rev > 0 || r.ec > 0;
      tr.querySelector(".c-rev").textContent = has ? eur(r.rev, 2) + " €" : "—";
      tr.querySelector(".c-ec").textContent = has ? eur(r.ec, 2) + " €" : "—";
      var roiC = tr.querySelector(".c-roi");
      if (r.roi) {
        roiC.innerHTML = '<span class="roi ' + (r.roi < 365 ? "roi-g" : r.roi < 730 ? "roi-a" : "roi-n") + '">' + r.roi + L.days + "</span>";
      } else { roiC.innerHTML = '<span class="mut">—</span>'; }
      var pfC = tr.querySelector(".c-pf");
      if (!has) { pfC.innerHTML = '<span class="mut">—</span>'; }
      else if (r.pf >= 0) { pfC.innerHTML = '<span class="pill pos">+' + eur(r.pf, 2) + ' €<small>' + L.day + '</small></span>'; }
      else { pfC.innerHTML = '<span class="pill neg">−' + eur(Math.abs(r.pf), 2) + ' €<small>' + L.day + '</small></span>'; }
    });
    /* podium top 3 — re-classé en direct selon le tarif saisi */
    var ranked = MINERS.slice().sort(function (a, b) {
      return (vals[b.id] ? vals[b.id].pf : -Infinity) - (vals[a.id] ? vals[a.id].pf : -Infinity);
    }).slice(0, 3);
    var cards = root.querySelectorAll(".mc-top");
    var medals = ["🥇", "🥈", "🥉"];
    ranked.forEach(function (m, i) {
      var card = cards[i], r = vals[m.id];
      if (!card || !r) return;
      card.className = "mc-top" + (i === 0 ? " mc-top-1" : "");
      card.innerHTML =
        '<div class="mc-top-rank">' + medals[i] + '<span>TOP ' + (i + 1) + '</span></div>' +
        '<h3 class="mc-top-name">' + m.n + '</h3>' +
        '<div class="mc-top-meta"><span class="cdot" style="background:' + D.cc[m.c] + '"></span>' +
          D.cn[m.c] + ' · ' + m.b + ' · ' + m.w.toLocaleString("fr-FR") + ' W</div>' +
        '<div class="mc-top-val"><span class="mc-topv num' + (r.pf < 0 ? " neg" : "") + '">' +
          (r.pf >= 0 ? "+" : "−") + eur(Math.abs(r.pf), 2) + ' €</span><small>' + L.perday + '</small></div>' +
        '<div class="mc-top-sub">' + L.priceLabel + ' <strong>' +
          (m.price ? m.price.toLocaleString("fr-FR", { maximumFractionDigits: 0 }) + " €" : "—") + '</strong>' +
          (m.pr ? '<span class="mc-top-pre">' + L.preorder + '</span>' : m.av ? '<span class="mc-top-stk">' + L.instock + '</span>' : m.st === "no" ? '<span class="mc-top-out">' + L.out + '</span>' : '') + '</div>' +
        (m.url ? '<a class="mc-top-cta" href="' + m.url + '">' + L.cta + '</a>' : '');
    });
  }

  function refreshTicker() {
    Array.prototype.forEach.call(root.querySelectorAll(".mc-coin"), function (b) {
      var c = b.getAttribute("data-coin");
      if (PRICES[c]) b.querySelector(".mc-coin-p").textContent = fmtPrice(PRICES[c].eur) + " €";
      b.classList.toggle("on", state.fC === c);
    });
  }

  function setStatus() {
    var s = root.querySelector("#mc-status");
    if (!s) return;
    if (live.prices && live.net) { s.textContent = L.live; s.classList.add("ok"); }
    else if (live.prices || live.net) { s.textContent = L.sync; }
  }
  function setHint() {
    var h = root.querySelector("#mc-hint");
    if (h) h.hidden = state.el > 0;
  }

  /* ---------- tri + filtres ---------- */
  function sortVal(m, k) {
    if (k === "rev" || k === "ec" || k === "pf") return vals[m.id] ? vals[m.id][k] : -Infinity;
    if (k === "roi") { var r = vals[m.id] && vals[m.id].roi; return r == null ? Infinity : r; }
    if (k === "price") return m.price || -Infinity;
    if (k === "st") return { ok: 0, pre: 1, no: 2, na: 3 }[m.st] || 4;
    if (k === "hr") return m.hr * (UNIT[m.u] || 1); /* tri normalisé toutes unités */
    var v = m[k];
    return typeof v === "string" ? v.toLowerCase() : (v == null ? -Infinity : v);
  }

  function apply() {
    var q = state.q.toLowerCase();
    var list = MINERS.filter(function (m) {
      if (state.fC && m.c !== state.fC) return false;
      if (state.fCl && m.cl !== state.fCl) return false;
      if (state.fB && m.b !== state.fB) return false;
      if (state.fA && m.a !== state.fA) return false;
      if (state.fS && m.st !== state.fS) return false;
      if (q && (m.n + " " + m.b + " " + m.c).toLowerCase().indexOf(q) < 0) return false;
      return true;
    });
    list.sort(function (a, b) {
      var va = sortVal(a, state.sortK), vb = sortVal(b, state.sortK);
      if (va === vb) return 0;
      var cmp = va > vb ? 1 : -1;
      return state.sortD === "asc" ? cmp : -cmp;
    });
    var visible = {};
    var frag = document.createDocumentFragment();
    list.forEach(function (m) { visible[m.id] = 1; frag.appendChild(rows[m.id]); });
    tbody.appendChild(frag); // réordonne les nœuds existants
    MINERS.forEach(function (m) { rows[m.id].hidden = !visible[m.id]; });
    var cnt = root.querySelector("#mc-count");
    if (cnt) cnt.textContent = list.length + " " + L.machines;
    /* indicateurs de tri */
    Array.prototype.forEach.call(root.querySelectorAll("th[data-k]"), function (th) {
      var on = th.getAttribute("data-k") === state.sortK;
      th.setAttribute("aria-sort", on ? (state.sortD === "asc" ? "ascending" : "descending") : "none");
      th.classList.toggle("on", on);
    });
    var msel = root.querySelector("#mc-msort");
    if (msel) msel.value = state.sortK + ":" + state.sortD;
  }

  /* ---------- événements (délégation) ---------- */
  root.addEventListener("click", function (e) {
    var th = e.target.closest && e.target.closest("th[data-k]");
    if (th) {
      var k = th.getAttribute("data-k");
      if (state.sortK === k) state.sortD = state.sortD === "asc" ? "desc" : "asc";
      else { state.sortK = k; state.sortD = (k === "n" || k === "a" || k === "c" || k === "st") ? "asc" : "desc"; }
      apply(); return;
    }
    var pre = e.target.closest && e.target.closest(".mc-pre");
    if (pre) {
      var pv = pre.getAttribute("data-el");
      var inp = root.querySelector("#mc-el");
      if (inp) inp.value = pv;
      state.el = parseFloat(pv) || 0;
      setHint(); refreshRows(); apply();
      return;
    }
    var coin = e.target.closest && e.target.closest(".mc-coin");
    if (coin) {
      var c = coin.getAttribute("data-coin");
      state.fC = state.fC === c ? "" : c;
      var sel = root.querySelector("#mc-fc"); if (sel) sel.value = state.fC;
      refreshTicker(); apply(); return;
    }
    var tr = e.target.closest && e.target.closest("tr[data-id]");
    if (tr && !(e.target.closest("a"))) {
      var a = tr.querySelector("a.mc-link");
      if (a) window.location.href = a.href;
    }
  });

  root.addEventListener("change", function (e) {
    var id = e.target.id;
    if (id === "mc-fc") { state.fC = e.target.value; refreshTicker(); apply(); }
    else if (id === "mc-fcl") { state.fCl = e.target.value; apply(); }
    else if (id === "mc-fb") { state.fB = e.target.value; apply(); }
    else if (id === "mc-fa") { state.fA = e.target.value; apply(); }
    else if (id === "mc-fs") { state.fS = e.target.value; apply(); }
    else if (id === "mc-el") {
      state.el = parseFloat(String(e.target.value).replace(",", ".")) || 0;
      setHint(); refreshRows(); apply();
    } else if (id === "mc-msort") {
      var p = e.target.value.split(":"); state.sortK = p[0]; state.sortD = p[1]; apply();
    }
  });

  var qTimer = null;
  root.addEventListener("input", function (e) {
    if (e.target.id !== "mc-q") return;
    clearTimeout(qTimer);
    var v = e.target.value;
    qTimer = setTimeout(function () { state.q = v; apply(); }, 120);
  });

  var rst = root.querySelector("#mc-reset");
  if (rst) rst.addEventListener("click", function () {
    state.fC = state.fCl = state.fB = state.fA = state.fS = state.q = "";
    ["mc-fc", "mc-fcl", "mc-fb", "mc-fa", "mc-fs", "mc-q"].forEach(function (i) {
      var el = root.querySelector("#" + i); if (el) el.value = "";
    });
    refreshTicker(); apply();
  });

  /* ---------- données live ---------- */
  function fetchPrices() {
    fetch("https://api.minent.eu/prices.json").then(function (r) {
      if (!r.ok) throw 0; return r.json();
    }).then(function (data) {
      Object.keys(CG).forEach(function (sym) {
        var d = data[CG[sym]];
        if (d && d.eur) PRICES[sym] = { eur: d.eur };
      });
      live.prices = true;
      refreshTicker(); refreshRows(); apply(); setStatus();
    }).catch(function () {});
  }
  function fetchNetwork() {
    fetch("https://api.minent.eu/network.json").then(function (r) {
      if (!r.ok) throw 0; return r.json();
    }).then(function (data) {
      var net = data.network || {};
      Object.keys(net).forEach(function (sym) {
        var c = net[sym]; if (!c || !c.nethash) return;
        var diff = c.difficulty || 0, nh = c.nethash, bt = c.block_time || 0, br = c.block_reward || 0;
        if (sym === "BTC" && diff > 1e12) NET.BTC = { type: "diff", diff: diff, reward: br };
        else if ((sym === "LTC" || sym === "DOGE") && diff > 0) NET[sym] = { type: "diff", diff: diff, reward: br };
        else if (nh > 0 && bt > 0 && br > 0) NET[sym] = { type: "nh", nh: nh, bt: bt, reward: br };
      });
      live.net = true;
      refreshRows(); apply(); setStatus();
    }).catch(function () {});
  }

  /* init : le HTML est déjà complet — on branche juste le live */
  setHint();
  refreshTicker();
  apply();
  fetchPrices();
  fetchNetwork();
  setInterval(fetchNetwork, 600000);
  setInterval(fetchPrices, 120000);
})();
